module.exports = __webpack_public_path__ + "img/64.ae34388f.jpg";